import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { User } from '../_models/user';
import { NewUser } from '../_models/new.user';

import { environment } from '../../environments/environment';

@Injectable()
export class UserService {
    constructor(private http: Http) { }

    createUser(user: NewUser) {
      let url = environment.apiUrl + 'users';
      let body = JSON.stringify(user);

      return this.http.post(url, body)
        .toPromise()
        .then((response: Response) => {
          if (response.status === 201) {
            return response.json();
          } else {
            throw response.json().error;
          }
        });
    }

    editUser(user: User) {
      let url = environment.apiUrl + 'users/' + user.id;
      let body = JSON.stringify(user);

      return this.http.patch(url, body)
        .toPromise()
        .then((response: Response) => {
            if (response.status === 200) {
              return response.json();
            } else {
              throw response.json().error;
            }
        });
    }

    passwordReset(username: string, password: string, token: string) {
      let url = environment.apiUrl + 'users/passwordreset/';
      let body = JSON.stringify({ username: username, password: password, token: token });
      return this.http.post(url, body)
        .toPromise()
        .then((response: Response) => {
          if (response.status === 201) {
            return true;
          } else {
            throw response.json().error;
          }
        });
    }

    sendPasswordReset(username: string) {
      let url = environment.apiUrl + 'users/sendpasswordreset/';
      let body = JSON.stringify({ username: username });

      return this.http.post(url, body)
        .toPromise()
        .then((response: Response) => {
          if (response.status === 201) {
            return true;
          } else {
            throw response.json().error;
          }
        });
    }

    getAll(): Promise<User[]> {
      return this.http.get(environment.apiUrl + 'users')
        .toPromise()
        .then((response: Response) => response.json())
        .catch(err => { throw err; });
    }

    getUser(id: number): Promise<User> {
        return this.http.get(environment.apiUrl + 'users/' + id)
          .toPromise()
          .then((response: Response) => { return response.json(); });
    }
}




// WEBPACK FOOTER //
// ./src/app/_services/user.service.ts